import moment									from 'moment';
import * as Sentry								from '@sentry/browser';

import {LoginData, User, UserState}				from './interface';

import {LanguageType} 							from '../../ressources/language/type';

import {getLocalStorage}						from '../../ressources/functions/localStorage';
import {ft_formatObjectIdToDate}				from '../../ressources/functions/format';

import * as API									from '../../ressources/API';


function errorObject(error: keyof LanguageType['login']['error'] | null = null) {
	return {
		error,
		data:            null,
		isAuthenticated: false,
		reload:          0
	};
}

function validObject(data: User) {
	window.dataLayer?.push({
		event:    'user-data-set',
		username: data?.email,
		signUpAt: moment(ft_formatObjectIdToDate(data?._id || '')).format('YYYY-MM-DDTHH:mm:ss')
	});

	Sentry.setUser({email: data?.email});

	return {
		data,
		error:           null,
		isAuthenticated: true,
		reload:          0
	};
}

export default {
	login: async (userData: LoginData) => {
		return new Promise<UserState>((resolve) => {
			if (!userData.email || !userData.password)
				return resolve(errorObject('empty'));

			return (
				API.login(userData)
				.then((response) => {
					if (!response || !response.status) {
						if (['mfa', 'wrongMfa'].some(f => f === response.error))
							return resolve(errorObject(response.error));
						return resolve(errorObject(response.error === 'Too many request' ? 'loginTooMany' : 'loginError'));
					}
					return resolve(validObject(response.data));
				})
			);
		});
	},

	checkIsConnected: async (forceUser?: {token: string, email: string}) => {
		return new Promise<UserState>((resolve) => {
			const user = forceUser || getLocalStorage('user');

			if (!user?.email)
				return resolve(errorObject());

			API.loginConfirm(user)
			.then((response) => {
				if (!response || !response.data || response.data.id_user !== user.id_user)
					return resolve(errorObject());

				response.data.token = user.token;
				return resolve(validObject(response.data));
			});
		});
	},

	switchUserCompany: async (idCompany: string) => {
		return new Promise<UserState>((resolve) => {
			const user = getLocalStorage('user');

			if (!user?.email)
				return resolve(errorObject());

			API.switchCompany(idCompany, user)
			.then((response) => {
				if (!response || !response.data || response.data.id_user !== user.id_user)
					return resolve(errorObject());
				response.data.token = user.token;
				return resolve(validObject(response.data));
			});
		});
	}
};
